"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
}); // @endindex
// @index('./*', pp => `import * as ${pp.name} from '${pp.path}';`, { "ignore": ["./*.ts", "./*.md"] })

var ConditionalHelper = require("./ConditionalHelper");

exports.ConditionalHelper = ConditionalHelper;

var redirect = require("./redirect");

exports.redirect = redirect;